import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import SuccessContainer from './SuccessContainer';
export default (function (_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/React.createElement(SuccessContainer, null, /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, "Thanks for signing up"), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, "We may reach out to you in the future to participate in additional research.")));
});